import { FillImageProps } from '@/lib/interfaces';
import Image, { ImageProps } from 'next/legacy/image';

export default function FillImage({
  height,
  width,
  alt = '',
  src,
  priority = false,
  objectFit = 'contain',
}: FillImageProps) {
  return (
    <div className={`relative ${height} ${width}`}>
      <Image
        priority={priority}
        alt={alt}
        src={src}
        layout="fill"
        objectFit={objectFit as ImageProps['objectFit'] | undefined}
      />
    </div>
  );
}
